// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * How use it:
 * 1. by dispatch:
 *      dispatch({ type: "xWarehouses/update", data: { key: "isStick", value: true } });
 *      data => it has "key" -> object key and value
 * 2. by handler:
 *      xWarehousesUpdate({ key: "isStick", value: true });
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xWarehousesStateType = Readonly<{
    industriesDataView: {
        isLoading?: boolean;
        industries?: string[];
    };
}>;

export const initialWarehousesState: xWarehousesStateType = {
    industriesDataView: {
        isLoading: false,
        industries: [],
    },
};

const reducer = {
    "xWarehouses/BeginLoadWarehousesIndustries": (draft: Draft<xWarehousesStateType>, action: { collection: string[] }) => {
        draft.industriesDataView.isLoading = true;
    },
    "xWarehouses/CompleteLoadWarehousesIndustries": (draft: Draft<xWarehousesStateType>, action: { collection: string[] }) => {
        draft.industriesDataView.isLoading = false;
        draft.industriesDataView.industries = action.collection;
    },
};

const xWarehouses = createTypedReducerWithImmer(initialWarehousesState, reducer);

(reducers as any).xWarehouses = xWarehouses;

export type xWarehousesState = {
    xWarehouses: xWarehousesStateType;
} & ApplicationState;

type xWarehousesReducers = {
    [key: string]: typeof xWarehouses;
};

export type xWarehousesActions = Parameters<xWarehousesReducers[keyof xWarehousesReducers]>[1] | AnyAction;
